export const siteName = "秘密教学动漫指南";

export const navItems = [
  { key: "home", label: "首页", to: "/" },
  { key: "episodes", label: "分集介绍", to: "/episodes" },
  { key: "characters", label: "角色图鉴", to: "/characters" },
  { key: "ending", label: "结局解析", to: "/ending" },
  { key: "about", label: "关于本站", to: "/about" },
];

export const storyOverview = [
  {
    title: "秘密身份的双重生活",
    text: "主角白天是循规蹈矩的校园优等生，夜晚却踏上了一条谁也不能说出口的隐秘修行之路。两种截然不同的身份在同一副躯体里不断拉扯，也一次次把他推向危险的边缘。",
  },
  {
    title: "亦师亦友的羁绊",
    text: "一位来历成谜的引路人，用最笨拙也最真挚的方式教会主角成长。师徒之间从戒备、试探到彼此交付信任，成为整部作品最动人的情感线索之一。",
  },
  {
    title: "层层逼近的真相",
    text: "看似平静的校园背后，隐藏着与主角身世相关的巨大谜团。每一话埋下的伏笔都像一根引线，最终串联成一张让人细思极恐的关系网。",
  },
  {
    title: "选择与代价",
    text: "秘密带来的力量并非没有代价。当主角终于掌握足以改变一切的能力，他也在一次次选择中明白：真正的强大，是学会承担选择后的结果。",
  },
];

export const episodes = [
  { ep: 1, title: "意外的相遇", tag: "开端", desc: "主角在回家的路上卷入一场意外，结识了改变他一生的引路人，秘密修行的帷幕自此拉开。", highlight: "身份对立的初次碰撞，为全篇埋下伏笔。" },
  { ep: 2, title: "第一课", tag: "修行", desc: "引路人开始向主角传授基础技法，主角笨拙而执着的模样让人忍俊不禁，也让人心头一暖。", highlight: "师徒关系的起点，细节里有大量可爱互动。" },
  { ep: 3, title: "深夜的秘密", tag: "校园", desc: "校园里接连发生的怪事让主角警觉，他开始意识到所谓的“秘密”或许远比他想象中复杂。", highlight: "校园线与修行线首次交汇。" },
  { ep: 4, title: "试探与信任", tag: "羁绊", desc: "主角发现引路人的过往并不简单，两人之间出现信任危机，却也因此在彼此面前展露了真实的一面。", highlight: "情感浓度极高的一话，名场面频出。" },
  { ep: 5, title: "风起云涌", tag: "冲突", desc: "一股不明势力盯上了主角，平静的日子被彻底打破，主角不得不第一次真正面对危险。", highlight: "动作场面密集，节奏骤然加快。" },
  { ep: 6, title: "抉择之夜", tag: "转折", desc: "两难的选择摆在主角面前，他必须在保护重要之人与守住秘密之间做出取舍。", highlight: "主线迎来第一个重大转折点。" },
  { ep: 7, title: "旧日的阴影", tag: "身世", desc: "关于主角身世的线索逐渐浮出水面，过去的阴影与现实交织，真相近在眼前。", highlight: "大量伏笔回收，信息量巨大。" },
  { ep: 8, title: "并肩作战", tag: "高潮", desc: "主角与同伴们第一次真正并肩作战，多年积累的信任与默契在这一刻爆发。", highlight: "群像塑造的高光时刻。" },
  { ep: 9, title: "真相大白", tag: "揭示", desc: "隐藏最深的秘密终于被揭开，主角不得不重新审视身边每一个人，包括他自己。", highlight: "核心谜团揭晓，观感冲击极强。" },
  { ep: 10, title: "至暗时刻", tag: "低谷", desc: "真相带来的打击让主角一度陷入低谷，也让他明白：真正的成长往往伴随着阵痛。", highlight: "情绪渲染到位，为结局蓄力。" },
  { ep: 11, title: "重拾初心", tag: "回归", desc: "在引路人与同伴的陪伴下，主角重新找回出发时的初心，决定直面属于自己的结局。", highlight: "温馨与热血并存的一话。" },
  { ep: 12, title: "新的黎明", tag: "结局", desc: "一切尘埃落定，主角在告别中学会释怀，也在新的起点上，迎来了属于自己的黎明。", highlight: "开放式结局，留白恰到好处。" },
];

export const characters = [
  {
    name: "林默",
    role: "主角",
    tagline: "白天优等生，夜晚修行者",
    desc: "看似普通的学生，却背负着不为人知的秘密。他敏感、倔强又温柔，在双重身份之间寻找真正的自己，是贯穿全篇的成长核心。",
    badge: "双重身份",
  },
  {
    name: "沈老师",
    role: "引路人",
    tagline: "亦师亦友的神秘导师",
    desc: "来历成谜的引路人，总是一副云淡风轻的模样，却在关键时刻永远站在主角身后。他的过往，是解开整部作品谜团的关键。",
    badge: "亦师亦友",
  },
  {
    name: "苏念",
    role: "同伴",
    tagline: "率真可靠的同窗挚友",
    desc: "主角最亲近的同伴之一，性格直率、重情重义。看似大大咧咧，实则心思细腻，总能在主角迷茫时拉他一把。",
    badge: "最佳搭档",
  },
  {
    name: "顾野",
    role: "对手",
    tagline: "冷静强势的宿命对手",
    desc: "与主角立场相对的神秘角色，实力强劲、目标明确。他与主角之间亦敌亦友的关系，为剧情注入了无数张力。",
    badge: "亦敌亦友",
  },
  {
    name: "阿芷",
    role: "守护",
    tagline: "看似文静的守护者",
    desc: "安静内向的少女，却藏着超乎常人的坚定。她用自己的方式守护着重要的人，是故事里最温柔的变量。",
    badge: "温柔坚定",
  },
  {
    name: "老教授",
    role: "幕后",
    tagline: "掌控全局的幕后智者",
    desc: "表面和蔼的老教授，实则与主角身世渊源极深。他的一举一动，都可能改变整个故事的走向。",
    badge: "深藏不露",
  },
];

export const originalCompare = [
  { point: "开篇视角", original: "原作以更多内心独白切入，情绪铺陈更细腻", anime: "动画以事件驱动开场，节奏更快、悬念更直接" },
  { point: "配角戏份", original: "原作中配角的支线故事更完整", anime: "动画压缩支线，把篇幅集中到主线与师徒情上" },
  { point: "名场面还原", original: "经典桥段的台词与分镜高度还原原作", anime: "动态演出与配乐加持，让名场面的冲击感更上一层" },
  { point: "结局处理", original: "原作结局偏开放式，留有大量想象空间", anime: "动画在原作基础上做了适度收束，情绪落点更明确" },
];

export const faqs = [
  {
    q: "秘密教学动漫讲了一个什么样的故事？",
    a: "它讲述一位普通学生在隐秘引路人的带领下，踏上不为人知的修行之路，并在校园生活、身世谜团与情感羁绊之间不断抉择、成长的群像故事。主线围绕“秘密”与“选择”两个关键词展开。",
  },
  {
    q: "动画一共有多少集，每集大概多长？",
    a: "以现有公开资料来看，主要剧情围绕十二话左右的核心章节展开，单集时长约二十分钟上下。具体集数可能随不同版本略有差异，建议以播放平台标注为准。",
  },
  {
    q: "和原作相比，动画做了哪些改编？",
    a: "动画大体遵循原作的剧情主线，但为了节奏更紧凑，对部分支线做了精简，同时强化了师徒这条情感线的刻画。喜欢原作的观众仍能找到大量高度还原的名场面。",
  },
  {
    q: "结局是开放式还是完整的？",
    a: "结局在回收主要伏笔的基础上采用了偏开放式的处理，既给出了清晰的情感落点，又为主角未来的可能性留下了想象空间，属于讨论度很高的收尾方式。",
  },
  {
    q: "看这部动漫前需要先补原作吗？",
    a: "不需要。动画在开篇会交代清楚世界观与人物关系，直接观看也能获得完整体验。当然，若想进一步了解细节与伏笔，再对照原作补一遍会有更丰富的乐趣。",
  },
  {
    q: "在哪里可以看到更多分集剧情解析？",
    a: "本站「分集介绍」栏目按集整理了每一话的剧情概要、亮点与伏笔，配合「结局解析」页面一起阅读，能帮你快速抓住全篇脉络与彩蛋。",
  },
];

export const galleryImages = [
  {
    title: "夜色下的修行",
    tag: "氛围感",
    img: "https://readdy.ai/api/search-image?query=stylish%20anime%20illustration%20of%20a%20young%20student%20silhouette%20standing%20under%20a%20moonlit%20night%20city%20with%20warm%20orange%20rim%20light%2C%20ink%20washes%20and%20sakuga%20linework%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20cinematic%20manga%20aesthetic%2C%20minimal%20clean%20composition&width=800&height=1000&seq=anime-hero-a1&orientation=portrait",
  },
  {
    title: "师徒的约定",
    tag: "名场面",
    img: "https://readdy.ai/api/search-image?query=warm%20anime%20illustration%20of%20a%20mentor%20and%20student%20silhouette%20facing%20each%20other%20in%20a%20sunlit%20classroom%2C%20soft%20golden%20hour%20light%2C%20ink%20wash%20background%2C%20warm%20amber%20and%20cream%20tones%2C%20emotional%20manga%20scene%2C%20clean%20cinematic%20composition&width=800&height=1000&seq=anime-hero-a2&orientation=portrait",
  },
  {
    title: "并肩的伙伴",
    tag: "羁绊",
    img: "https://readdy.ai/api/search-image?query=stylish%20anime%20illustration%20of%20a%20group%20of%20teen%20friends%20standing%20together%20in%20front%20of%20a%20school%20building%20at%20sunset%2C%20warm%20orange%20and%20brown%20palette%2C%20ink%20washes%2C%20energetic%20manga%20character%20design%2C%20clean%20cinematic%20composition&width=800&height=1000&seq=anime-hero-a3&orientation=portrait",
  },
  {
    title: "迷雾中的真相",
    tag: "悬疑",
    img: "https://readdy.ai/api/search-image?query=mysterious%20anime%20illustration%20of%20a%20hooded%20figure%20half%20hidden%20in%20shadow%20among%20old%20bookshelves%2C%20dramatic%20low%20key%20lighting%20with%20warm%20amber%20accents%2C%20ink%20wash%20style%2C%20deep%20brown%20and%20dark%20tones%2C%20suspenseful%20manga%20aesthetic%2C%20clean%20composition&width=800&height=1000&seq=anime-hero-a4&orientation=portrait",
  },
];